<template>
  <div class="gw-box shadow">
		<div class="gw-box-header center">
			<h4>Repertoire</h4>
		</div>
		<div class="gw-box-body">
			<input class="search-input" v-model="searchValue" placeholder="Search songs..." @input="filterSongs" />
			
			<div class="song gw-btn fill" v-for="(song, i) in filteredSongs" :key="i">
				<div class="song-info">
					<div class="song-title">{{song.title}}</div>
					<div class="song-author-composer" v-if="song.author">{{song.author}}</div>
					<div class="song-author-composer" v-if="song.composer">{{song.composer}}</div>
				</div>
				<div class="song-labels">
					<div class="song-label" v-for="(label,i) in song.labels" :key="i">{{label}}</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>

let localSongs = [{
	title: 'Angelus',
	labels: ['classical','relaxing']
},{
	title: 'Ballade',
	labels: ['classical','relaxing'],
	composer: 'Susann MacDonald'
},{
	title: 'Bourree (Music for the Royal Fireworks)',
	labels: ['classical','relaxing'],
	composer: 'Handel'
},{
	title: 'Dreams of Spring',
	labels: ['relaxing']
},{
	title: 'Fountain in the Rain',
	labels: ['relaxing']
},{
	title: 'Gavotte',
	labels: ['classical','relaxing'],
	composer: 'Handel'
},{
	title: 'Gavotte (Iphegenia in Aulis)',
	labels: ['classical','relaxing'],
	composer: 'von Gluck'
},{
	title: 'Interlude',
	labels: ['classical','relaxing'],
	composer: 'MacDonald'
},{
	title: 'Interlude (Ceremony of Carols)',
	labels: ['classical','relaxing'],
	composer: 'Britten'
},{
	title: 'Largo (Xerxes)',
	labels: ['classical'],
	composer: 'Handel'
},{
	title: 'Melody',
	labels: ['classical','relaxing'],
	composer: 'R Schumann'
},{
	title: 'Minuet in G',
	labels: ['classical','relaxing'],
	composer: 'JS Bach'
},{
	title: 'Minuet in G minor',
	labels: ['classical','relaxing'],
	composer: 'Rousseau'
},{
	title: 'Morning',
	labels: ['classical','relaxing'],
	composer: 'Grieg'
},{
	title: 'Peace Be With You',
	labels: ['relaxing']
},{
	title: 'Quietude',
	labels: ['relaxing']
},{
	title: 'Serenade',
	labels: ['classical','relaxing']
},{
	title: 'Strolling Musicians',
	labels: ['relaxing'],
	composer: 'Rebikov'
},{
	title: 'The Nightingale',
	labels: ['relaxing'],
	composer: 'Deborah Henson-Conant'
},{
	title: 'Le Bon Petit Roi d\'Yvetot',
	labels: ['classical','relaxing'],
	composer: 'Grandjany'
},{
	title: 'Sonata in C minor',
	labels: ['classical','relaxing'],
	composer: 'Pescetti'
},{
	title: 'Canon In D',
	labels: ['classical','relaxing','wedding'],
	composer: 'Pachelbel'
},{
	title: 'Here Comes the Bride (Bridal March from Lohengrin)',
	labels: ['classical','wedding'],
	composer: 'Wagner'
},{
	title: 'Jesu, Joy of Man\'s Desiring',
	labels: ['classical','wedding','upbeat'],
	composer: 'JS Bach'
},{
	title: 'Sheep May Safely Graze',
	labels: ['classical','wedding'],
	composer: 'JS Bach'
},{
	title: 'Trumpet Tune',
	labels: ['classical','wedding','upbeat'],
	composer: 'Purcell'
},{
	title: 'Trumpet Voluntary',
	labels: ['classical','wedding','upbeat'],
	composer: 'Purcell'
},{
	title: 'Wedding March (Midsummer Night\'s Dream)',
	labels: ['classical','wedding'],
	composer: 'Mendelssohn'
},{
	title: 'Concerto in Bb',
	labels: ['classical','upbeat'],
	composer: 'Handel'
},{
	title: 'Dream Habanera',
	labels: ['upbeat']
},{
	title: 'Fanny Power',
	labels: ['upbeat'],
	composer: 'O\'Carolan'
},{
	title: 'Lucky Crickets',
	labels: ['upbeat'],
	composer: 'Aimee Raechel'
},{
	title: 'Petite Valse',
	labels: ['classical','upbeat']
},{
	title: 'Rumba',
	labels: ['classical','upbeat'],
	composer: 'Salzedo'
},{
	title: 'Seguidilla',
	labels: ['classical','upbeat'],
	composer: 'Salzedo'
},{
	title: 'Star of the County Down',
	labels: ['upbeat']
},{
	title: 'Toccata- Sabre Dance',
	labels: ['classical','upbeat']
},{
	title: 'Two Guitars',
	labels: ['upbeat']
},{
	title: 'All I Ask of You (Phantom of the Opera)',
	labels: ['movie','relaxing','love','wedding']
},{
	title: 'Everybody Wants to Be a Cat (The Aristocats)',
	labels: ['movie','upbeat']
},{
	title: 'Love Theme (The Godfather)',
	labels: ['movie','relaxing','love']
},{
	title: 'Many Meetings (Lord of the Rings)',
	labels: ['movie','relaxing']
},{
	title: 'Memory (Cats)',
	labels: ['movie','relaxing','love']
},{
	title: 'My Heart Will Go On (Titanic)',
	labels: ['movie','relaxing','love','wedding']
},{
	title: 'One Hand, One Heart (West Side Story)',
	labels: ['movie','relaxing','love','wedding']
},{
	title: 'Only the Beginning of the Adventure (Chronicles of Narnia)',
	labels: ['movie','relaxing','love']
},{
	title: 'Somewhere My Love (Dr. Zhivago)',
	labels: ['movie','relaxing','love','wedding']
},{
	title: 'Tale as Old as Time (Beauty and the Beast)',
	labels: ['movie','relaxing','love']
},{
	title: 'Tammy',
	labels: ['relaxing','love']
},{
	title: 'The Rose',
	labels: ['relaxing','love','wedding']
},{
	title: 'Theme from Love Story',
	labels: ['movie','relaxing','love']
},{
	title: 'Think of Me (Phantom of the Opera)',
	labels: ['movie','relaxing','love']
},{
	title: 'Through the Eyes of Love (Ice Castles)',
	labels: ['movie','relaxing','love']
},{
	title: 'Wind Beneath My Wings',
	labels: ['relaxing','love','wedding']
},{
	title: 'Puff the Magic Dragon',
	labels: ['movie']
},{
	title: 'As The Deer',
	labels: ['sacred','relaxing']
},{
	title: 'Change My Heart, O God',
	labels: ['sacred']
},{
	title: 'Give Thanks',
	labels: ['sacred']
},{
	title: 'In Moments Like These',
	labels: ['sacred']
},{
	title: 'Make Me a Servant',
	labels: ['sacred']
},{
	title: 'Morning Has Broken',
	labels: ['sacred']
},{
	title: 'O Perfect Love',
	labels: ['sacred','love','wedding']
},{
	title: 'Simple Gifts',
	labels: ['sacred']
},{
	title: 'Softly and Tenderly',
	labels: ['sacred']
},{
	title: 'The Prayer (sung by Celine Dion and Andrea Boccelli)',
	labels: ['sacred','wedding']
},{
	title: 'What a Friend We Have in Jesus',
	labels: ['sacred','upbeat']
},{
	title: 'Wondrous Love/ Wondrous Cross (What Wondrous Love is This and When I Survey the Wondrous Cross)',
	labels: ['sacred','relaxing']
},{
	title: 'You Raise Me Up',
	labels: ['sacred','love']
},{
	title: 'Angels We Have Heard on High',
	labels: ['christmas']
},{
	title: 'Arabian Dance of the Three Kings',
	labels: ['christmas','classical']
},{
	title: 'Away in a Manger',
	labels: ['christmas','relaxing']
},{
	title: 'Christ Was Born on Christmas Day',
	labels: ['christmas']
},{
	title: 'Coventry Carol',
	labels: ['christmas']
},{
	title: 'Deck the Halls',
	labels: ['christmas']
},{
	title: 'Ding Dong Merrily on High',
	labels: ['christmas']
},{
	title: 'Go, Tell It On the Mountain',
	labels: ['christmas']
},{
	title: 'God Rest Ye, Merry Gentlemen',
	labels: ['christmas']
},{
	title: 'Good Christian Men, Rejoice',
	labels: ['christmas']
},{
	title: 'Good King Wenceslas',
	labels: ['christmas']
},{
	title: 'Hark! The Herald Angels Sing',
	labels: ['christmas']
},{
	title: 'He Is Born',
	labels: ['christmas']
},{
	title: 'Here We Come a\'Wassailing',
	labels: ['christmas']
},{
	title: 'I Saw Three Ships',
	labels: ['christmas']
},{
	title: 'I Wonder as I Wander',
	labels: ['christmas','relaxing']
},{
	title: 'Infant Holy',
	labels: ['christmas','relaxing']
},{
	title: 'It Came Upon a Midnight Clear',
	labels: ['christmas','relaxing']
},{
	title: 'O Come All Ye Faithful',
	labels: ['christmas']
},{
	title: 'O Holy Night',
	labels: ['christmas','relaxing']
},{
	title: 'O Tannenbaum',
	labels: ['christmas']
},{
	title: 'Silent Night',
	labels: ['christmas','relaxing']
},{
	title: 'The Angels and the Shepherds',
	labels: ['christmas']
},{
	title: 'The First Noel',
	labels: ['christmas','relaxing']
},{
	title: 'The Holly and the Ivy',
	labels: ['christmas','relaxing']
},{
	title: 'What Child is This/ Greensleeves',
	labels: ['christmas','relaxing','classical']
},{
	title: 'We Wish You a Merry Christmas',
	labels: ['christmas']
},{
	title: 'While By My Sheep',
	labels: ['christmas','relaxing']
},{
	title: 'While Shepherds Watched Their Flocks',
	labels: ['christmas']
}];

export default {
  name: 'Repertoire',
  data () {
    return {
			queryOptions: [{
				label: 'Title',
				field: 'title',
				comparison: 'contains',
				freeform: true
			},{
				label: 'Composer',
				field: 'composer',
				comparison: 'contains',
				freeform: true
			},{
				label: 'Type',
				field: 'labels',
				type: 'array',
				value: 'Classical',
				comparison: 'equals'
			}],
			songs: localSongs,
			filteredSongs: [],
			searchValue: ''
		}
	},
	components: {
	},
	created() {
		this.$data.songs = this.$data.songs.sort(function(a, b) {
			if(a.title > b.title) {
				return 1;
			} else if(a.title < b.title) {
				return -1;
			}
			
			return 0;
		});
		
		this.$data.filteredSongs = this.$data.songs;
	},
	methods: {
		onFilter: function(filteredSongs) {
			this.$data.filteredSongs = filteredSongs;
		},
		
		filterSongs: function() {
			let value = this.$data.searchValue.toLowerCase();
			let songs = [];
			
			if(!value) {
				songs = this.$data.songs;
			} else {
				for(let i = 0; i < this.$data.songs.length; i++) {
					let song = this.$data.songs[i];
					
					if(song.title && song.title.toLowerCase().indexOf(value) >= 0) {
						songs.push(song);
					} else if(song.composer && song.composer.toLowerCase().indexOf(value) >= 0) {
						songs.push(song);
					} else if(song.author && song.author.toLowerCase().indexOf(value) >= 0) {
						songs.push(song);
					}
				}
			}
			
			this.$data.filteredSongs = JSON.parse(JSON.stringify(songs));
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.song.gw-btn {
		cursor: initial;
	}
	
	.search-input {
		border: none;
		padding: 4px;
		font-size: 16px;
		margin: 4px;
		width: calc(100% - 16px);
	}
</style>
